import { FC } from 'react';
import { FileText } from 'lucide-react';

interface ArticleDisplayProps {
    value: number | string | undefined;
}

/**
 * Professional data-chip style display for total articles count
 * Design consistent with FrequencyDisplay but tailored for total count
 */
export const ArticleDisplay: FC<ArticleDisplayProps> = ({ value }) => {
    const articles = typeof value === 'number'
        ? value
        : typeof value === 'string'
            ? parseInt(value, 10)
            : null;

    if (articles === null || isNaN(articles)) {
        return (
            <span className="text-sm text-gray-400 font-medium">N/A</span>
        );
    }

    return (
        <div className="flex items-center gap-2 group w-fit">
            {/* Icon Container - using a subtle indigo theme for Articles */}
            <div className="flex items-center justify-center w-7 h-7 rounded-md bg-white border border-gray-100 group-hover:border-indigo-300 group-hover:bg-indigo-50 transition-all duration-200 shadow-sm">
                <FileText className="w-3.5 h-3.5 text-gray-400 group-hover:text-indigo-500 transition-colors" />
            </div>

            {/* Text Container */}
            <div className="flex flex-col leading-[1.1]">
                <div className="flex items-baseline gap-1">
                    <span className="text-sm font-bold text-gray-900 tabular-nums">
                        {articles}
                    </span>
                    <span className="text-[11px] font-semibold text-gray-500">
                        Posts
                    </span>
                </div>
                <span className="text-[9px] text-gray-400 font-bold uppercase tracking-wider">
                    Total Analyzed
                </span>
            </div>
        </div>
    );
};
